module.exports = __webpack_public_path__ + "static/media/Consolas-01.acdeea59.svg";